module.exports = __webpack_public_path__ + "static/img/shape_12.3af808e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_12.png
// module id = UKqA
// module chunks = 0